import styled from 'styled-components';

export const TreeWrapper = styled.div`
  margin: -12px 0 20px 0;
`;
